import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ResourceInfoDc } from "@evergis/api";

import { api } from "../../../evergis/api";
import { setReferenceLayerInfos } from "../../../ducks/showFeature/showFeature";
import { getLayerInfo } from "../../../evergis/core/layer/getLayerInfo";
import { getReferenceLayerInfos } from "../../../ducks/showFeature/selectors";
import { useDefaultScaleRange } from "../../../hooks/style/useDefaultScaleRange";
import { ConfigDataSource } from "../types";

export const useReferenceLayerInfos = (configDataSources?: ConfigDataSource[]) => {
  const dispatch = useDispatch();
  const layerInfos = useSelector(getReferenceLayerInfos);
  const defaultScaleRange = useDefaultScaleRange();

  const fetchData = useCallback(() => {
    const newDataSources = layerInfos?.length
      ? configDataSources?.filter(item => !layerInfos.some(({ name }) => name === item.name))
      : configDataSources;

    if (!newDataSources?.length) return;

    const promisesArray = newDataSources
      .filter(
        ({ layerName }, index) => layerName && newDataSources.findIndex(item => item.layerName === layerName) === index,
      )
      .map(({ layerName }) => api.layers.findOne(layerName));

    Promise.allSettled(promisesArray).then(data => {
      dispatch(
        setReferenceLayerInfos([
          ...(layerInfos || []),
          ...data
            .filter(({ status }) => status !== "rejected")
            .map(({ value }: PromiseFulfilledResult<ResourceInfoDc>) => getLayerInfo(value, defaultScaleRange)),
        ]),
      );
    });
  }, [configDataSources, defaultScaleRange, dispatch, layerInfos]);

  useEffect(() => {
    fetchData();
  }, [configDataSources]);
};
